module.exports = __webpack_public_path__ + "img/double-arrows-white.bcc8d59c.svg";